var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-state-datetime"},[_c('DatePicker',{attrs:{"value":_vm._value,"format":_vm.format,"type":"datetime"},on:{"input":function($event){_vm.$emit('input',_vm.$moment($event).format(_vm.format))}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }